var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { ImageViewer } from '../ImageViewer';
export class ImageList extends Component {
    constructor() {
        super('ImageList', false);
        this.currentImages = [];
        this.currentImagesIndex = 0;
        ImageList.currentInstance = this;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            const eventName = $(window).width() > 991 ? 'mouseenter' : 'click';
            $('.component-image-list[data-status="interactiv"] a').on(eventName, (event) => {
                this.currentImagesIndex = 0;
                const linkElement = $(event.currentTarget);
                const images = linkElement.data('images').split(',');
                if (images === this.currentImages && $(window).width() > 991)
                    return;
                $('.component-image-viewer img, .component-image-viewer .caption').remove();
                if (images.length > 0) {
                    $('.component-image-viewer-spinner').removeClass('d-none');
                    this.loadImage(images[this.currentImagesIndex], parseFloat($('.component-image-list a[data-images*="' + images[this.currentImagesIndex] + '"]').data('aspectRatios').split(',')[this.currentImagesIndex]));
                    $('.component-image-viewer').append(linkElement.find('.caption').clone().addClass('position-lg-absolute d-lg-none').removeClass('d-none'));
                }
                if (images.length > 1) {
                    $('.component-image-viewer-navigation').removeClass('d-none').addClass('d-flex').empty();
                    $('.component-image-viewer-interactiv-area').addClass('is-gallery');
                    for (let i = 0; i < images.length; i++) {
                        $('.component-image-viewer-navigation').append($.parseHTML(`<a class="component-image-viewer-navigation-dot d-block ${i === this.currentImagesIndex ? 'bg-primary' : 'bg-white'}"></a>`));
                    }
                }
                else {
                    $('.component-image-viewer-navigation').addClass('d-none').removeClass('d-flex');
                    $('.component-image-viewer-interactiv-area').removeClass('is-gallery');
                }
                this.currentImages = images;
            }).on('click', (event, link) => {
                if (link.hasClass('position-absolute'))
                    return;
                event.preventDefault();
            });
            $('body').on('click', '.component-image-viewer-navigation a', (event, dot) => {
                const navigationDots = $('.component-image-viewer-navigation a');
                const images = this.currentImages;
                if (images.length === 0)
                    return;
                navigationDots.removeClass('bg-primary').addClass('bg-white');
                dot.removeClass('bg-white').addClass('bg-primary');
                this.currentImagesIndex = dot.index();
                this.loadImage(images[this.currentImagesIndex], parseFloat($('.component-image-list a[data-images*="' + images[this.currentImagesIndex] + '"]').data('aspectRatios').split(',')[this.currentImagesIndex]));
            });
            this.success();
        });
    }
    loadImage(imageUrl, aspectRatio = 0) {
        $('.component-image-viewer').removeClass('d-none').addClass('d-flex');
        $('.component-image-viewer-spinner').removeClass('d-none');
        const imageElement = $(new Image());
        imageElement.attr('src', imageUrl);
        imageElement.on('load', () => {
            $('.component-image-viewer-image img').remove();
            $('.component-image-viewer-image').prepend(imageElement);
            $('.component-image-viewer-spinner').addClass('d-none');
            ImageViewer.resize();
        });
        ImageViewer.currentAspectRatio = aspectRatio;
    }
    loadNextImage() {
        const images = this.currentImages;
        if (images.length === 0)
            return;
        this.currentImagesIndex = (this.currentImagesIndex + 1) % images.length;
        $('.component-image-viewer-navigation a').removeClass('bg-primary').addClass('bg-white').eq(this.currentImagesIndex).removeClass('bg-white').addClass('bg-primary');
        this.loadImage(images[this.currentImagesIndex], parseFloat($('.component-image-list a[data-images*="' + images[this.currentImagesIndex] + '"]').data('aspectRatios').split(',')[this.currentImagesIndex]));
    }
    loadPreviousImage() {
        const images = this.currentImages;
        if (images.length === 0)
            return;
        this.currentImagesIndex = (this.currentImagesIndex - 1 + images.length) % images.length;
        $('.component-image-viewer-navigation a').removeClass('bg-primary').addClass('bg-white').eq(this.currentImagesIndex).removeClass('bg-white').addClass('bg-primary');
        this.loadImage(images[this.currentImagesIndex], parseFloat($('.component-image-list a[data-images*="' + images[this.currentImagesIndex] + '"]').data('aspectRatios').split(',')[this.currentImagesIndex]));
    }
}
